import { render, staticRenderFns } from "./SupportDetail.vue?vue&type=template&id=a9e9fada"
import script from "./SupportDetail.vue?vue&type=script&lang=js"
export * from "./SupportDetail.vue?vue&type=script&lang=js"
import style0 from "./SupportDetail.vue?vue&type=style&index=0&id=a9e9fada&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports